import { render, staticRenderFns } from "./InitialLettersIcon.vue?vue&type=template&id=f738e4d4"
import script from "./InitialLettersIcon.vue?vue&type=script&lang=js"
export * from "./InitialLettersIcon.vue?vue&type=script&lang=js"
import style0 from "./InitialLettersIcon.vue?vue&type=style&index=0&id=f738e4d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports